import './CSS/Estilo.css';
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar";
import MenuDesplegable from "./Componentes/MenuDesplegable";
import {useState, useEffect, useCallback} from "react";
import Box from '@mui/system/Box';
import Link from '@mui/material/Link';
import { List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import WebTheme from "./Componentes/SubComponentes/WebTheme";
import {CajaTexto, RotuloWebPequeno} from "./Componentes/SubComponentes/CajasTexto";
import {Web} from "@mui/icons-material";
import Footer from "./Componentes/SubComponentes/Footer";
//import Grid from '@mui/material/Grid';

export default function OraxAboutUs({modo}){
    console.log("Entra en Sobre nosotros");

    const opciones = ['Dark','Green']
    const pages = [ 'Inicio', 'Noticias y Actividades','Contacto','Área privada' ];

    const [estiloPagina,setEstiloPagina]=useState((localStorage.getItem('estilo') === 'Dark')?estiloDark
        :estiloGreen);

    const opcionesOnClick = useCallback((ev) => {
        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark')?estiloDark:estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo',pulsado);
    },[]);

    const lista = ['Conocimiento, difusión y resolución de la problemática del mundo de la enfermedad y la discapacidad.',
                   'Dirección y gestión de servicios de promoción personal, cultural, integración social y residencias, sin ánimo de lucro.',
                   'Colaboración con todos aquellos organismos, entidades y asociaciones que ayuden a lograr los objetivos anteriores.',
                   'Contacto periódico y personalizado con todos nuestros miembros.',
                   'Promoción entre los miembros mediante la formación del compromiso socio-político y la presencia activa en la sociedad.',
                   'Establecimiento de equipos de vida y formación.',
                  ];
    const textoSobreNosotros = (<>
                            Frater Barcelona es una de las sedes de la <Link href="https://www.fratersp.org/\" target="_blank"> Fraternidad Cristiana de Personas con discapacidad de España
                            </Link>{' '}, y, por tanto, miembro de la Fraternidad Cristiana Intercontinental de Personas con enfermedades crónicas y discapacidades físicas.
                            <br/>Fue creada hace 60 años, con los mismos postulados que el movimiento original, fundado en 1945 por el párroco francés <Link href="https://www.fratersp.org/publicaciones/padre-francois/"
                            target="_blank">Padre François</Link>.<br/><br/>
                            La nuestra es una organización transversal, sin ánimo de lucro, formada por personas sencillas que buscan compartir su fe más allá de los
                            valores impuestos por el mundo deshumanizado y de competencia absurda en el que nos encontramos. A nivel global, cuenta con más de 5000 miembros en todo
                            el mundo, con amplia representación en América latina y África además de Europa.
                            </>);


    return(
        <Box className='Cont' style={{background:estiloPagina.background}}>
            <Box className='ToolBar'>
                <ToolBar
                    gadgets={[
                        <MenuDesplegable
                            key='1'
                            opciones={opciones}
                            opcionesOnClick={opcionesOnClick}>
                        </MenuDesplegable>]}
                    paginas={pages}
                    estilo ={estiloPagina}
                    modo = {modo}>
                </ToolBar>
            </Box>
            <Box className='Cabecera'>
                <h1 style={{margin:'auto',color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,fontWeight:200}}>
                    Sobre nosotros
                </h1>
            </Box>

    <Box className = 'AreaNegocio' style={{background:estiloPagina.background}} >
        {/*Primer bloque */}
        <Box sx={{
            display: 'flex',
            width: '98%',
            alignItems: 'stretch',
            border: (estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen,
            ml:'1%'}}>
            {/* Imagen-frater - 20% */}
            <Box
                component="img"
                src="/sede_frater.png"
                alt="Logo Frater"
                sx={{
                    width: '20vw',
                    height: 'auto',
                    objectFit: 'contain',
                    ml:'10px',
                    mr:'10px',
                }}
            >
            </Box>

            {/* Texto 1 - 80% */}
            <Box
                sx={{
                    width: '75vw', // 80% de la ventana
                    padding: 2,
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'arial',
                    fontWeight: 700,
                    letterSpacing: '.2rem',
                    fontSize: '1.3em',
                    color: {color:(estiloPagina.background === "black")?WebTheme.colors.letraDark:WebTheme.colors.letraGreen},
                    textDecoration: 'none',
                }}>
                <CajaTexto texto = {textoSobreNosotros} estiloPagina={estiloPagina} margintop={'0'} marginLeft = {'0px'}></CajaTexto>
            </Box>
        </Box>

        <Box sx={{display:'flex',width:'100%'}}>
        {/* Caja con lista actividades - 50% */}
        <Box sx={{ display: 'block', width: '50%',alignItems: 'center', border: (estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen, mt:'1%',ml:'1%'}}>
            <RotuloWebPequeno texto={'Misión de la organización'} estiloPagina={estiloPagina}></RotuloWebPequeno>
            <List sx={{display:'block',}} >
                { lista.map((item, index) =>(
                    <ListItem key={index}>
                        <ListItemIcon sx={{ minWidth: 24, color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen }}>
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: (estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
                                }}
                            />
                        </ListItemIcon>
                        <CajaTexto texto={item} altoLetra={'2em'} estiloPagina={estiloPagina} marginTop={'0'}></CajaTexto>
                    </ListItem>
                    ))}
            </List>
        </Box>

        {/* Caja con organigrama - 50% */}
            <Box sx={{width: '47%',border: estiloPagina.background === 'black' ? WebTheme.borderLines.lineaDark : WebTheme.borderLines.lineaGreen,mt:'1%',ml:'1%'}}>
                <RotuloWebPequeno texto={'Organigrama'} estiloPagina={estiloPagina}></RotuloWebPequeno>
                <Box component="img"
                     src="/organigrama.png"
                     alt="Logo Frater"
                     sx={{
                         width:'98%',
                         height: 'auto',
                         objectFit: 'contain',
                         ml:'10px',
                         mr:'10px',
                         mt:'2%',
                         display:'block',
                         background:'yellow'
                     }}>
                  </Box>
            </Box>
        </Box>{/*Caja contenedora actividades y organigrama */}

    </Box>{/* Areanegocio */}
            <Footer estilo={estiloPagina} modo={modo}></Footer>
</Box>
    );
}

